import './slider.scss';
export function generateSliders(element) {
  var sliderNeeded = document.querySelectorAll(element + '[data-slider]');
  if (sliderNeeded) {
    sliderNeeded.forEach(function ($this) {
      var sliderConfiguration = $this.getAttribute('data-slider');
      sliderConfiguration = JSON.parse(sliderConfiguration);
      import('tiny-slider/src/tiny-slider').then(({
        tns
      }) => {
        // Import Tiny slider css
        import('./tiny-slider.scss');

        // Not override-able settings for the slider that need to be defined
        sliderConfiguration['container'] = $this;
        sliderConfiguration['mouseDrag'] = true;
        sliderConfiguration['nav'] = false;
        sliderConfiguration['autoplayButton'] = false;
        sliderConfiguration['autoplayButtonOutput'] = false;
        sliderConfiguration['controlsText'] = [theme_object.filters.slider_icon_previous, theme_object.filters.slider_icon_next];
        if (sliderConfiguration['variables'] != undefined) {
          if (sliderConfiguration['variables']['controlsPosition'] != undefined) {
            var controlsPosition = sliderConfiguration['variables']['controlsPosition'];
          }
        }

        // Initialize the Tiny Slider
        var slider = tns(sliderConfiguration);
        $this.classList.add('slider-initialized');
        if (controlsPosition != undefined) {
          var sliderOuter = $this.parentElement.parentElement.parentElement;
          sliderOuter.querySelector('.tns-controls').classList.add(controlsPosition);
        }
      }).catch(error => {
        console.error("Error loading Tiny Slider:", error);
      });
    });
  }
}